export const tpaParadigmPackager = (getTpaParadigmQuestions) =>
  getTpaParadigmQuestions
    .filter((q) => q.paradigmAlias)
    .reduce((acc, cur) => ({ ...acc, [cur.paradigmAlias]: cur }), {});
